import type { FC } from 'react';
import { useTheme } from 'styled-components';
import type { IIconsProps } from './types';
import { IconScale } from './types';

const BookOpenLine: FC<IIconsProps> = ({
  color,
  size = IconScale.M,
}: IIconsProps) => {
  const theme = useTheme();
  if (!color) {
    color = theme.palette.primary.main;
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M8.66659 14V15.3333H7.33325V14H1.99992C1.63173 14 1.33325 13.7015 1.33325 13.3333V2.66667C1.33325 2.29848 1.63173 2 1.99992 2H5.99992C6.79639 2 7.51132 2.34917 7.99992 2.90279C8.48852 2.34917 9.20345 2 9.99992 2H13.9999C14.3681 2 14.6666 2.29848 14.6666 2.66667V13.3333C14.6666 13.7015 14.3681 14 13.9999 14H8.66659ZM13.3333 12.6667V3.33333H9.99992C9.26352 3.33333 8.66659 3.93029 8.66659 4.66667V12.6667H13.3333ZM7.33325 12.6667V4.66667C7.33325 3.93029 6.73632 3.33333 5.99992 3.33333H2.66659V12.6667H7.33325Z"
        fill={color}
      />
    </svg>
  );
};

export default BookOpenLine;
